"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalize = void 0;
var normalize = function (arr, idKey) {
    return arr.reduce(function (acc, item) {
        acc[item[idKey]] = item;
        return acc;
    }, {});
};
exports.normalize = normalize;
